var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 34.5,
    height: 34.5,
    rx: 17.25,
    fill: "#FAB005"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 34.5,
    height: 34.5,
    rx: 17.25,
    stroke: "white",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5858 8.58579C15.9609 8.21071 16.4696 8 17 8H26C26.5304 8 27.0391 8.21071 27.4142 8.58579C27.7893 8.96086 28 9.46957 28 10V20C28 20.4045 27.7564 20.7691 27.3827 20.9239C27.009 21.0787 26.5789 20.9931 26.2929 20.7071L23.5858 18H17C16.4696 18 15.9609 17.7893 15.5858 17.4142C15.2107 17.0391 15 16.5304 15 16V10C15 9.46957 15.2107 8.96086 15.5858 8.58579ZM26 10H17V16H24C24.2652 16 24.5196 16.1054 24.7071 16.2929L26 17.5858V10ZM8.58579 15.5858C8.96086 15.2107 9.46957 15 10 15H12C12.5523 15 13 15.4477 13 16C13 16.5523 12.5523 17 12 17H10V24.5858L11.2929 23.2929C11.4804 23.1054 11.7348 23 12 23H19V21C19 20.4477 19.4477 20 20 20C20.5523 20 21 20.4477 21 21V23C21 23.5304 20.7893 24.0391 20.4142 24.4142C20.0391 24.7893 19.5304 25 19 25H12.4142L9.70711 27.7071C9.42111 27.9931 8.99099 28.0787 8.61732 27.9239C8.24364 27.7691 8 27.4045 8 27V17C8 16.4696 8.21071 15.9609 8.58579 15.5858Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.d23ab39b715613fa6636e2052d247d1d.svg";
export { ForwardRef as ReactComponent };